import { ethers } from "ethers";
import NFTAbi from "./musclex.json";
import NFTStakingABI from "./stakingContractTwo.json";

export const inProduction = true;

export const StakingContractAddress = inProduction
  ? "0x7D742567bC8d7Bd6Ed3dD94daE31cC1A41ACc5E9"
  : "0x82c1f2a20214573ee1ec321d91AF1Eccc2F42979";

export const NFTContractAddress = inProduction
  ? "0x0B10991d041827Da2c8787bf8C076453C0f40EeD"
  : "0x4DcBB552D972937c4033968Db030B158EFb8bCfa";

let signer;
if (window.ethereum !== undefined) {
  const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
  signer = provider.getSigner();
}

export const nftContract = new ethers.Contract(
  NFTContractAddress,
  NFTAbi,
  signer
);
export const nftStakingContract = new ethers.Contract(
  StakingContractAddress,
  NFTStakingABI,
  signer
);
